import { createPinia } from 'pinia'
import loggerPlugin from '@/stores/plugins/logger'

const ENABLE_LOGGING = import.meta.env.VITE_LOG_STORE_TO_CONSOLE === 'true'

const pinia = createPinia()

// Plugins
if (import.meta.env.DEV && ENABLE_LOGGING) {
  pinia.use(loggerPlugin)
}

export { pinia as default }
